import * as z from "zod";
import { linxIntegrationSchema, linxSettingsInputSchema } from "./shared";

export const setLinxIntegration = {
  name: "setLinxIntegration" as const,
  input: linxSettingsInputSchema,
  output: z.object({ integration: linxIntegrationSchema }),
};
